import React from 'react';
import MainSectionContainer from "./MainSectionContainer";
import SectionControls from "./controls/SectionControls";

const MainControlPanel = () => {
  
  return (
    
    <div className="main-selection-container">
      
      <MainSectionContainer sectionName={'controls'} component={<SectionControls/>}/>
      
    </div >
  )
};


export default MainControlPanel;



